import { randomBetween, randomBoolean } from '@/mixins/random';
import { wrapLines, wrapWords, wrapCharacters } from '@/mixins/text-wrapper';
import { setElementStyles } from '@/mixins/element-attrs';

export default {
	methods: {
		buildLineArray(text) {
			return wrapLines(text, "span", {
				class: "line",
			});
		},
		buildWordArray(text) {
			return wrapWords(text, "span", {
				class: "word",
			});
		},
		buildLetterArray(text) {
			return wrapCharacters(text, "span", {
				class: "letter",
			});
		},
		scrambleText(letters) {
			letters.forEach((letter, index) => {
				const offset = randomBetween(-3, 3);
				const rotation = randomBetween(-3, 3);

				// ensure last letter has no transforms to allow for falling letter
				if (index < letters.length - 1) {
					setElementStyles(letter, {
						display: "inline-block",
						transform: `translateY(${offset}px) rotate(${rotation}deg)`,
						fontFamily: randomBoolean() ? "Oduda" : "Helvetica",
					});
				}
			});

			return letters;
		},
	},
};



// WEBPACK FOOTER //
// ./src/mixins/scramble-text.js